export enum ICON_TYPE {
  LOGOUT = 'LOGOUT',
}
